import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import useLeadChannelStore from '../leadChannelStore/useLeadChannelStore';
import useParameterStore from '../parameterStore/useParameterStore';
import { signUpStore } from './signUpStore';

const useSignUpStore = createStore({
  creator: signUpStore({
    useLeadChannelStore: lazyDependency(() => useLeadChannelStore),
    useParameterStore: lazyDependency(() => useParameterStore),
  }),
  id: 'signUp',
  middlewares: {
    devtools: true,
    persist: true,
  },
});

export default useSignUpStore;
